import { Button, Form, Input, Modal } from "antd";
import Context from "context/appContext";
import { useContext, useEffect } from "react";
import { useState } from "react";
import { getValueField, validateForm } from "utils/utils";
import SelectField from "../select";
import TextField from "../text";
import EliminarImg from "../../../assets/images/trash.svg";
// @styles
import "./styles.scss";

export default function CardEdit({ info, form, key, current }) {
  const [minClass, setMinClass] = useState("max");
  const [showCard, setShowCard] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imageCardEdit, setimageCardEdit] = useState("");
  const [copyComponent, setCopyComponent] = useState({});
  const [keys, setKeys] = useState([]);
  const [isEdit, setIsEdit] = useState(false);


  const {
    dataForm: { data, formResponses },
    customRequest,
    typePerson,
    checked
  } = useContext(Context);

  const keysItem = {
    rfcPreferente: true,
    razonSocialPreferente: true,
    regimenFiscalPreferenteContratante: true,
    codigoPostalFacturacionPreferenteContratante: true,
  };

  useEffect(() => {
    let fieldsValue = {};
    const fields = info && info.components && info.components.map(field => field.input === true && field.key).filter(x => x);
    setKeys(fields);
    fields && fields.forEach(x => {
      fieldsValue[x] = getValueField(x, formResponses);
    })
    setCopyComponent(fieldsValue);
    if (info.properties) {
      setimageCardEdit(info.properties.imgcard);
    }
  }, [info])

  useEffect(() => {
    const indexPanel = formResponses.findIndex(x => x.key === info.key);
    if (indexPanel !== -1) {
      const active = formResponses[indexPanel] && formResponses[indexPanel].active;
      setShowCard(active);
      setMinClass(active ? 'min' : 'max');
    } else {
      formResponses.push(info)
    }
  }, []);

  useEffect(() => {
    setActive();
  }, [showCard])

  useEffect(() => {
    if (Object.keys(typePerson).length > 0 && info.key === 'panelContratante' && showCard) {
      deleteCard(false);

    }
  }, [typePerson])

  const setActive = () => {
    const indexPanel = formResponses.findIndex(x => x.key === info.key);
    if (indexPanel !== -1) {
      formResponses[indexPanel]['active'] = showCard;
    } else {
      info['active'] = showCard;
      formResponses.push(info);
    }
  }

  const saveClass = async () => {
    if (await validateForm(keys, form) && (await validateCodePostal())) {
      saveCopyComponent(info);
      setMinClass('min');
    }
  }

  const saveCopyComponent = (info) => {
    let fieldsValue = {};
    const components = info.components.filter((field) => keysItem[field.key]);
    if (components && components.length) {
      components.forEach((component) => {
        const value = form.getFieldValue(component.key);
        const index = formResponses.findIndex((x) => x.key === component.key);
        component.value = value;
        index !== -1 ? formResponses[index] = component : formResponses.push(component);
        fieldsValue[component.key] = value;
      });
    }
    setCopyComponent(fieldsValue);
  }

  const editClass = () => {
    setIsEdit(true);
    setFieldsValue();
    setMinClass("max");
  };

  const setFieldsValue = () => {
    copyComponent && Object.keys(copyComponent) && Object.keys(copyComponent).length > 0 && Object.keys(copyComponent).forEach(x => {
      form.setFieldsValue({ [x]: copyComponent[x] });
    })

  }

  const getUrlCode = (opciones_servicio) => {
    let codePostal = getValueField(
      "codigoPostalFacturacionPreferenteContratante",
      formResponses
    );
    const opcionesServicio = JSON.parse(opciones_servicio);
    if (!opcionesServicio.url.toLowerCase().includes("http")) {
      opcionesServicio.url = `${process.env.REACT_APP_BACKEND}${opcionesServicio.url}`;
    }
    opcionesServicio.url = opcionesServicio.url.replace("value", codePostal);
    return opcionesServicio;
  };

  const validateCodePostal = async () => {
    let validate = true;
    const findCode = info.components.find(
      (e) => e.key === "codigoPostalFacturacionPreferenteContratante"
    );

    if (findCode && findCode.logic && findCode.logic.length) {
      setLoading(true);
      const json = findCode.logic[0].trigger.json;
      const dataLcl = JSON.stringify(json);
      const opciones_servicio = getUrlCode(dataLcl);
      const response = await customRequest(
        opciones_servicio.url,
        opciones_servicio.headers,
        opciones_servicio.method,
        opciones_servicio.body
      );
      if (response && !response.success && response.message) {
        configModal(
          "El Código Postal no es válido.",
          "Aceptar",
          "Ops!"
        );
        validate = false;
      }
    }
    setLoading(false);
    return validate;
  };

  const configModal = (message, btnOk, title) => {
    Modal.info({
      icon: "",
      title: title,
      className: "modal-confirm",
      closable: false,
      okButtonProps: {
        className: "ant-btn-solid c-2 ant-btn-size-xs margin-s",
      },
      okText: btnOk,
      content: <p>{message}</p>,
      onOk() { },
    });
  };

  const getDescriptions = (name) => {
    if (name) {
      const description = info.components.find(
        (field) => field && field.label === name
      );
      return description && description.html;
    }
  };

  const deleteCard = (modal) => {
    if (modal) {
      configModal(info && info.properties && info.properties.delete ? info.properties.delete : '¿Estás seguro de eliminar tu Beneficiario Preferente?',
        'Aceptar',
        'Confirmación')
    } else {
      setCopyComponent({});
      setIsEdit(false);
      setActive();
      setShowCard(!showCard);

      keys.forEach(key => {
        setFieldsValue(key, '', null, formResponses, form);
        const index = formResponses.findIndex(x => x.key === key);
        if (index !== -1) {
          formResponses[index].value = '';
        }
      })
      form.resetFields(keys);
      setMinClass('max');
    }
  }

  const cancelCard = () => {
    if (isEdit) {
      const components = info.components.filter((field) => keysItem[field.key]);
      if (components && components.length) {
        components.forEach((component) => {
          const value = copyComponent[component.key];
          const index = formResponses.findIndex((x) => x.key === component.key);
          component.value = value;
          index !== -1 ? formResponses[index] = component : formResponses.push(component);
          form.setFieldsValue({ [component.key]: value });
        });
      }
      setMinClass("min");
    } else {
      deleteCard(false);
    }
  }

  const enableCard = () => {
    setShowCard(!showCard);
  };

  return (
    <div className="beneficiary-container">
      {!showCard && (
        <div className="beneficiary-container__btn">
          <Button
            className="ant-btn-outline c-2 ant-btn-size-xxs"
            data-testid="enable-btn"
            onClick={() => enableCard()}
          >
            {
              info && info.title ? info.title : ''

            }
          </Button>
        </div>
      )}
      {showCard && (
        <div className={`beneficiary-container__item ${minClass}`}>
          <div className="beneficiary-container__item-header">
            <img
              src={imageCardEdit}
              alt=  {info?.title}
              className="beneficiary-container__item-header__img"
            />
            <div className="beneficiary-container__item-header__text">
              <div className="beneficiary-container__item-header__text-title">
                {info && info.title}
              </div>
              <div className="beneficiary-container__item-header__text-description">
                <div className="beneficiary-container__item-header__text-description-text">
                  {info && info.components.map((field) =>
                    field && field.label !== "informacion" && field.label !== "Descripcion" && <strong>{field.label}</strong>
                  )
                  }
                </div>
                <div className="beneficiary-container__item-header__text-description-actions">
                  <em
                    className="fal fa-pencil-alt"
                    onClick={editClass}
                    data-testid="btn-edit-class"
                  />
                  <div onClick={() => deleteCard(false)}>
                    <img src={EliminarImg} alt="Imagen icono eliminar" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="beneficiary-container__item-body">
            <div className="beneficiary-container__item-body-text">
              <td
                dangerouslySetInnerHTML={{
                  __html: getDescriptions("Descripcion"),
                }}
              />
            </div>
            <div className="beneficiary-container__item-body-form">
              <Form form={form}>
                {info &&
                  info.components.map(
                    (field) =>
                      (field && field.type === "textfield" && (
                        <TextField
                          info={field}
                          form={form}
                          key={field.key}
                          current={current}
                        />
                      )) ||
                      (field.type === "select" && (
                        <SelectField
                          info={field}
                          form={form}
                          key={field.key}
                          current={current}
                        />
                      ))
                  )}
              </Form>
            </div>
            <div className="beneficiary-container__item-body-text">
              <td
                dangerouslySetInnerHTML={{
                  __html: getDescriptions("informacion"),
                }}
              />
            </div>
            <div className="beneficiary-container__item-body-actions">
              <Button
                className="ant-btn-text c-2 ant-btn-size-xs"
                onClick={() => cancelCard()}
              >
                <strong>Cancelar</strong>
              </Button>
              <Button
                className="ant-btn-outline c-2 ant-btn-size-xs"
                data-testid="btn-save-class"
                onClick={saveClass}
                loading={loading}
              >
                <strong>Guardar</strong>
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
